import { getStatus, isStatus } from '@/utils'
import { DOCUMENT_STATUSES } from '../constants'
import type { Document, DocumentStatus, DocumentStatusKey } from '../stores'

export const isDocumentProcessing = (document: Document) =>
  isDocumentStatus(document, 'recognizing', 'indexing', 'enqueued')

export const isDocumentToStart = (document: Document) =>
  isDocumentStatus(document, 'notStarted', 'failed')

export const hasDocumentFailed = (document: Document) =>
  isDocumentStatus(document, 'failed')

export const isDocumentStatus = (
  document: Document,
  ...expectations: DocumentStatusKey[]
) => isStatus(DOCUMENT_STATUSES, document, 'status', ...expectations)

export const getDocumentStatus = (value: DocumentStatus) =>
  getStatus(DOCUMENT_STATUSES, value)
